import { cn } from '@discover-lib/utils';

export default function Pre({ className, ...props }: React.ComponentPropsWithoutRef<'pre'>) {
  return <pre className={cn('m-0 p-1 leading-none', className)} {...props} />;
}
